import styled from 'styled-components';

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
  padding-left: ${({ theme }) => theme.constants.lateralSpace};
  height: 68px;
  background: ${({ theme }) => theme.colors.corporateWhite};
`;

export default FooterContainer;
